export const pageData = {

    Martellus: {
        title: 'Martellus Bennett',
        cta: "Discover Martellus Bennett's story",
        nextPanel: 'Deadmau5',
        previousPanel: 'contest',
        quote: 'Take all those ideas you like or you’re attracted to... turn them into your own thing, and you become&nbsp;yourself.',
        galleryLabel: 'The original world of Martellus Bennett and Surface ',
        images: [],
        content: {
            title: 'Rewriting the script on&nbsp;original',
            description: 'Martellus Bennett is more than an author. He’s a multi-disciplined world builder, inspired by experiences and his environment to create new narratives for the next generation. His inspirations can strike anywhere at any time, so the key to his process is being ready to capture it wherever he goes—with the help of Surface&nbsp;Duo.'
        },
        video: {
            poster: '',
            url:'https://msobd-storage.azureedge.net/videos/marty_16x9.mp4',
            portraitUrl:'https://msobd-storage.azureedge.net/videos/marty_9x16.mp4',
            cc: 'video/marty.vtt'
        },
        product: {
            title: 'Martellus’s Surface Kit',
            subTitle: 'Catch inspiration on the fly',
            products: [
                {
                    image: 'https://msobd-storage.azureedge.net/images/360/SurfaceDuo.png',
                    animation: {
                        w: 500,
                        h: 15500,
                        f:31
                    },
                    imageAlt:'Surface Duo',
                    title: 'Surface Duo',
                    description: 'Bring your ideas to life on a device that’s as multifaceted as you are. Ink creativity that spans pages with a dual touchscreen and Surface Pen, and get the best of both Android and Microsoft 365—all in&nbsp;your&nbsp;pocket.',
                    linkUrl: 'https://www.microsoft.com/surface/devices/surface-duo?activetab=overview',
                    linkText: 'Explore now'
                },
                {
                    image: 'https://msobd-storage.azureedge.net/images/360/SurfaceEarbuds.png',
                    animation: {
                        w: 500,
                        h: 15500,
                        f:31
                    },
                    imageAlt:'Surface Earbuds',
                    title: 'Surface Earbuds',
                    description: 'Immerse yourself in what inspires you. Featuring an ultra-comfortable design, intuitive controls, access to the Microsoft 365 suite, and all-day battery that keeps you in the flow wherever&nbsp;you&nbsp;go.',
                    linkUrl: 'https://www.microsoft.com/p/surface-earbuds/8r9cpq146064?activetab=pivot%3aoverviewtab',
                    linkText: 'Explore now'
                }
            ]
        }
    },
    Deadmau5: {
        title: 'deadmau5',
        cta: 'Uncover the mind of <span>deadmau5</span>',
        nextPanel: 'Cache',
        previousPanel: 'Martellus',
        quote: 'That’s the cool thing about original ideas... how they propagate in a community to create new&nbsp;trends.',
        galleryLabel: 'The original world of deadmau5 and Surface',
        images: [],
        content: {
            title: 'Capturing sounds to sculpt new&nbsp;ones',
            description: 'There\'s only so many keys and notes, but deadmau5, the electronic music pioneer, uniquely arranges them to create an original sound. That\'s how he changed the audio landscape from the moment he emerged on the scene—and Surface has been instrumental in elevating his creative process, music and&nbsp;light&nbsp;shows.'
        },
        video: {
            poster: 'https://msobd-storage.azureedge.net/images/profile_deadmau5/poster.jpg',
            url:'https://msobd-storage.azureedge.net/videos/deadmau5_16x9.mp4',
            portraitUrl:'https://msobd-storage.azureedge.net/videos/deadmau5_9x16.mp4',
            cc: 'video/deadmau5.vtt'
        },
        product: {
            title: 'deadmau5’s Surface Kit',
            subTitle: 'Mixed and mastered to inspire ',
            products: [
                {
                    image: 'https://msobd-storage.azureedge.net/images/360/SurfaceStudio2.png',
                    animation: {
                        w: 500,
                        h: 15500,
                        f:31
                    },
                    imageAlt:'Surface Studio 2',
                    title: 'Surface Studio 2',
                    description: 'Original ideas come to life on Surface Studio 2. Find your creative rhythm with high-fidelity colors, a speed-of-sound graphics processor, and more—all on a beautiful 28&quot;&nbsp;touchscreen&nbsp;display.',
                    linkUrl: 'https://www.microsoft.com/p/surface-studio-2/8sbjxm0m58t4?activetab=pivot%3aoverviewtab',
                    linkText: 'Explore now'
                },
                {
                    image: 'https://msobd-storage.azureedge.net/images/360/SurfacePro7.png',
                    animation: {
                        w: 500,
                        h: 15500,
                        f:31
                    },
                    imageAlt:'Surface Pro 7',
                    title: 'Surface Pro 7',
                    description: 'Fine-tuned for what inspires you. Turn up your originality with an ultra-light and versatile 2-in-1 laptop featuring all-day battery&nbsp;life.',
                    linkUrl: 'https://www.microsoft.com/p/surface-pro-7/8n17j0m5zzqs?activetab=overview',
                    linkText: 'Explore now'
                }
            ]
        }
    },
    Cache: {
        title: 'Cache Bunny',
        cta: "Hop into Cache Bunny's world",
        nextPanel: 'Brooke',
        previousPanel: 'martellus',
        quote: 'Being original is just bringing your own unique perspective... and combining things in a new&nbsp;way.',
        images: [],
        content: {
            title: 'Putting fresh spins on&nbsp;creativity',
            description: 'Cache Bunny creates reality-bending visual effects like no one else. But in her eyes, originality isn’t doing what’s never been done before. It starts by seeing what exists around her, and then making it her own. With the help of Surface, she puts her own twist on the sights and sounds that inspire her, creating a distinct, personified art form in&nbsp;the&nbsp;process.',
        },
        video: {
            poster: '',
            url:'https://msobd-storage.azureedge.net/videos/cache_16x9.mp4',
            portraitUrl: 'https://msobd-storage.azureedge.net/videos/cache_9x16.mp4',
            cc: 'video/cache.vtt'
        },
        product: {
            title: 'Cache Bunny’s Surface&nbsp;Kit',
            subTitle: 'A new perspective on performance',
            products: [
                {
                    image: 'https://msobd-storage.azureedge.net/images/360/SurfaceBook3.png',
                    animation: {
                        w: 500,
                        h: 15500,
                        f:31
                    },
                    imageAlt:'Surface Book 3',
                    title: 'Surface Book 3',
                    description: 'Power your boldest, brightest creations with amazing speed, beautiful graphics on 13" or 15" touchscreens, and the versatility of a laptop, tablet, and portable studio—all in one device that’s set for whatever scene&nbsp;you’re&nbsp;in. ',
                    linkUrl: 'https://www.microsoft.com/p/surface-book-3/8xbw9g3z71f1?activetab=pivot%3aoverviewtab',
                    linkText: 'Explore now'
                },
                {
                    image: 'https://msobd-storage.azureedge.net/images/360/SurfacePro7.png',
                    animation: {
                        w: 500,
                        h: 15500,
                        f:31
                    },
                    imageAlt:'Surface Pro 7',
                    title: 'Surface Pro 7',
                    description: 'Flip the script on what your device can do for you. Adapt your ideas with powerful performance in an ultra-light and versatile 2-in-1 design featuring all-day battery that’s set for whatever scene&nbsp;you’re&nbsp;in.',
                    linkUrl: 'https://www.microsoft.com/p/surface-pro-7/8n17j0m5zzqs?activetab=overview',
                    linkText: 'Explore now'
                }
            ]
        }
    },
    Brooke:{
        title: 'Brooke Shaden',
        cta: "See through Brooke Shaden's lens",
        nextPanel: 'spotlight',
        previousPanel: 'cache',
        quote: 'The design that the world has given you and how you interact with that&mdash;that’s where originality comes&nbsp;from.',
        images: [],
        content: {
            title: 'The world is her starting&nbsp;point ',
            description: 'Brooke Shaden reshapes the inspiration our real, physical world gives her to create portraits that inspire new emotions and perspectives in others. It starts with her camera, capturing natural landscapes that set the scene for her work. Then, using Surface, she injects new life into those landscapes with fantastical characters and visuals that tell deeply personal stories, inspiring us all to rethink the relationship between our inner, original selves and the natural world that&nbsp;surrounds&nbsp;us.'
        },
        video: {
            poster: '',
            url:'https://msobd-storage.azureedge.net/videos/brooke_16x9.mp4',
            portraitUrl:'https://msobd-storage.azureedge.net/videos/brooke_9x16.mp4',
            cc: 'video/brooke.vtt'
        },
        product: {
            title: 'Brooke’s Surface Kit',
            subTitle: 'Powering inspiration from the outside in',
            products: [
                {
                    image: 'https://msobd-storage.azureedge.net/images/360/SurfaceStudio2.png',
                    animation: {
                        w: 500,
                        h: 15500,
                        f:31
                    },
                    imageAlt:'Surface Studio 2',
                    title: 'Surface Studio 2',
                    description: 'See the bigger picture in everything you create. Bring your ideas to the foreground with a large 28” display, and picture new possibilities with blazing graphics, hyper-fast processing speed, and a host of intuitive&nbsp;tools.',
                    linkUrl: 'https://www.microsoft.com/p/surface-studio-2/8sbjxm0m58t4?activetab=pivot%3aoverviewtab',
                    linkText: 'Explore now'
                },
                {
                    image: 'https://msobd-storage.azureedge.net/images/360/SurfacePro7.png',
                    animation: {
                        w: 500,
                        h: 15500,
                        f:31
                    },
                    imageAlt:'Surface Pro 7',
                    title: 'Surface Pro 7',
                    description: 'Frame what inspires you with sleek, world-class performance in an ultra-light and versatile 2-in-1 laptop, featuring all-day battery for all the places your imagination will&nbsp;take&nbsp;you.',
                    linkUrl: 'https://www.microsoft.com/p/surface-pro-7/8n17j0m5zzqs?activetab=overview',
                    linkText: 'Explore now'
                }
            ]
        }
    }
}